import {MultiselectInput} from "../MultiselectInput";
import {SubscriptionCoverage} from "../../../client/state/SubscriptionCoverageStore";
import {SubscriptionOffer} from "../../../client/state/SubscriptionOfferStore.js";
import {TreeViewCheckbox} from "../../../stem-core/ui/input/checkbox/TreeViewCheckbox.jsx";
import type {Merchant} from "../../../client/state/MerchantStore";
import type {TreeEntry} from "../../../stem-core/ui/input/checkbox/TreeViewCheckbox";


interface SubscriptionCoverageMultiselectInputOptions {
    merchant?: Merchant;
    includeInactive?: boolean;
    ignore?: SubscriptionCoverage;
}

export class SubscriptionCoverageMultiselectInput extends MultiselectInput<SubscriptionCoverageMultiselectInputOptions> {
    getAllOptions() {
        const {merchant, ignore, includeInactive} = this.options;
        let entries = SubscriptionCoverage.filterBy({merchantId: merchant.id}).filter(sub => sub != ignore);
        if (!includeInactive) {
            entries = entries.filter(entry => entry.isAvailable());
        }
        return entries;
    }

    getSelectedSubscriptionCoverageIds() {
        return this.getValue().map(coverage => coverage.id);
    }
}

interface SubscriptionOffersMultiselectInputOptions {
    merchant?: Merchant;
    includeInactive?: boolean;
    subscriptionOffers?: SubscriptionOffer[];
}

export class SubscriptionOffersMultiselectInput extends TreeViewCheckbox<SubscriptionOffersMultiselectInputOptions> {
    getDefaultEntries(options: this["options"]) {
        const {merchant, includeInactive, subscriptionOffers} = options;
        const subscriptionCoverages = SubscriptionCoverage.filterBy({merchantId: merchant.id});
        let entries: TreeEntry[] = [];
        for (const coverage of subscriptionCoverages) {
            let coverageOffers = (subscriptionOffers || SubscriptionOffer.all())
                .filter(offer => offer.coverageId === coverage.id);
            if (!includeInactive) {
                coverageOffers = coverageOffers.filter(plan => plan.isAvailable());
            }
            if (coverageOffers.length) {
                entries.push({
                    label: `${coverage} — ${coverageOffers.length} plan${coverageOffers.length > 1 ? "s" : ""}`,
                    value: null, // Means ignored
                    children: coverageOffers.map(o => ({
                        label: o.formatBasePrice(),
                        value: o,
                        checked: true,
                    })),
                });
            }
        }

        return entries;
    }

    getDefaultOptions(options?: this["options"]) {
        return {
            entries: this.getDefaultEntries(options),
        }
    }

    // TODO @cleanup a bit unclean how we preserve state here
    getPreservedOptions() {
        return {
            entries: this.options.entries
        };
    }

    allSelected() {
        return this.allChecked();
    }

    getSelectedSubscriptionOfferIds() {
        const selectedSubscriptionOffers = this.getValue();
        return selectedSubscriptionOffers.map((offer: SubscriptionOffer) => offer.id);
    }
}
